import React from "react";
import "./Introduction.css";

export default function Introduction() {
  return (
    <section className="introduction-section">
      <div className="container">
        <h2>Introduction</h2>

        <p>
          Education in India during ancient times was culturally, spiritually rooted and encompassed a holistic learning that possibly led to a peaceful, prosperous and powerful society and economy. Gradual withering of political establishments combined with plunders and rule by savage raiders during the medieval times, saw a fusion of education colliding with a compromise, contradiction and of course supplementary wings added to it. However, little gains and big losses left a deep scar on the national character of India as a whole which concluded with only yet another storm of colonization with the onset of the British Raj.  
        </p>

        <p>
          Education suffered its worst, survived with its spirit of wisdom and even attained its best sneaking opportunity of exposure to world’s intellect, wisdom and modern science under socio-economic currents of its time. However, the cumulative disruptions left independent India with a complex educational landscape.
        </p>

        <p>
          Over the last seven decades, great initiatives and incessant corrective measures and reforms have been attempted; while a lot is achieved; yet, the fundamental purpose of education, learning in crisis in schools is ills-plaguing and eventually has been observed to cascade to low graduate employability challenging the basic veracity of quality of education. 
        </p>

        <p>
          The National Education Policy (NEP) 2020 marks a decisive shift. It recognizes the strengths of India’s ancient and medieval educational traditions while addressing the structural and pedagogical barriers that evolved over time. Drawing cumulative merits from previous policies and aligning with the global aspiration of SDG 4, NEP 2020 brings a renewed emphasis on holistic development, quality learning, and outcome-oriented education. 
        </p>

        <p>
          Besides quality learning through education, encompassing requisite knowledge, skills, dispositions and values, aiming individuals to become good human beings, responsible citizens, and productive contributors to the nation’s economy—whether through self-employment or as part of the wider workforce shall make it fulfilling.
        </p>

        <p><strong>
          As one of the premier think tanks dedicated to Fundamental & Applied Research on Principles, Practices & Policy on Indian Education, we are committed to contribute to mitigate learning crisis and its cascading effect on low graduate employment by strengthening pedagogical practices, instructional strategies and methods across school and higher education.  
        </strong></p>

        <p><strong>
          In order to achieve this, ‘Pan-India Strategic Dialogue Series in Learning-Teaching Advancement’ SDSLTA-PI shall be initiated open to representations from all stake-holders. After end of each session, document in the form of ‘Insights Notes’ shall be recorded and a series of these Insight Notes as Annual Cohesive Synthesis Report on ‘Strategic Dialogue Series in Learning-Teaching Advancement ’ shall be published and submitted to Government. 
        </strong></p>

        <div className="author">
          <p><strong>K V Atriya</strong></p>
          <p>Founder President — The Brigade Educational Trust</p>
        </div>
      </div>
    </section>
  );
}
